
export default {
  props: {
    tabs: {
      default: (_) => [],
    },
  },
  data(){
    return{
        active:this.tabs[0]
    }
  },methods:{
    clearSelection(){
        for (const t of this.tabs) {
            t.active= false;
        }
    }
  }
};
